// --- CLEAN + FIXED VERSION --- //

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs, orderBy, limit } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import banner_default from "../../assets/banner_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { Randomcode } from "../../components_root/rendom_code.js";

import {
    MdArrowBackIos,
    MdClose,
    MdAccountCircle,
    MdPrint,
    MdSaveAs
} from "react-icons/md";

import { Uploader_files } from "../../components_root/uploader_files.js";
import { Update_voucher } from "../vouchers_root/Update_voucher.js";
import "./voucher_entry.css";
import AmountToWords from "../../components_root/AmountToWords.js";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import { Randomnumber } from "../../components_root/rendom_number.js";
import Account_list_profile_popup from "../ledger_accounts_root/account_list_profile_popup.jsx";
import { Save_voucher_ledger } from "./save_voucher_ledger.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools",
    description: "Discover free & premium online services on aooz.",
    keywords: "tools, seo, utilities",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

// -----------------------
// FORMAT 13 DIGIT ACCOUNT NUMBER
// -----------------------
export function formatAccountNumber(num, length = 13) {
    if (!num) return "";
    return String(num).padStart(length, "0");
}

export default function Journal_voucher_entry({ slug }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const servicetablename = "accountingfinancedb";
    const [voucherid, setVoucherid] = useState("");
    const [voucherprintid, setVoucherprintid] = useState(Randomcode(22));
    const [vouchernumber, setvouchernumber] = useState(Randomnumber(10));
    const [voucher, setVoucher] = useState("");
    const [voucher_type, setVoucher_type] = useState("");
    const [amount, setAmount] = useState("");
    const [totalamount, setTotalamount] = useState(0);
    const [description, setdescription] = useState("");
    // const [slug, setSlug] = useState("");
    const [voucherdate, setVoucherdate] = useState("");
    const [print, setPrint] = useState(false);

    const [fromsearchstatus, setFromsearchstatus] = useState(false);
    const [tosearchstatus, setTosearchstatus] = useState(false);

    const [from_accountguid, setFrom_accountguid] = useState("");
    const [to_accountguid, setTo_accountguid] = useState("");
    const [to_accountdata, setTo_accountdata] = useState([]);
    const [from_accountdata, setFrom_accountdata] = useState([]);
    const [vouchersdata, setVouchersdata] = useState([]);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);

    const [logo_file, setLogo_file] = useState(null);
    const [logoUrl, setLogoUrl] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [printId, setPrintId] = useState();
    const [BannerUrl, setBannerUrl] = useState("");
    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");
    const [refer_number, setRefer_number] = useState("");
    const [remarks, setRemarks] = useState("");
    const [companyData, setCompanyData] = useState([]);
    const receiptnumber = Randomnumber(13);
    const select_company_uid = Cookies.get("select_company_uid");
    const [to_balance, setTo_balance] = useState(0);
    const [balance, setBalance] = useState(0);
    const [profileopen, setProfileopen] = useState(false);
    // -----------------------
    // SET DATE
    // -----------------------
    useEffect(() => {
        setVoucherdate(new Date().toLocaleString());
    }, []);
    const handle_save_voucher = async () => {

        if (!voucherprintid) {
            Toastshow("Print ID missing");
            return;
        }
        if (!voucher_type?.trim()) {
            Toastshow("Missing voucher_type");
            return
        }

        if (!amount || Number(amount) === 0) {
            Toastshow("Please enter amount");
            return;
        }
        const payload = {
            voucher,
            description,
            remarks,
            refer_number,
            voucherid,
            voucherprintid,
            vouchernumber,
            voucher_type,
            from_accountguid,
            to_accountguid,
            status: true,
            namepaying: to_accountdata?.name || "",
            mobile: to_accountdata?.mobile || "",
            accountnumber: to_accountdata?.accountnumber || "",
            payment_method_online: false,
            amount: Number(amount) || 0,
            totalamount: Number(totalamount) || 0
        };
        const result = await Save_voucher_ledger(payload);
        if (result.success) {
            if (print === true) setPrintId(voucherprintid);
            setvouchernumber(Randomnumber(10));
            setVoucherprintid(Randomcode(22));
            setAmount("");
            setTotalamount("");
            setVoucherdate(new Date().toLocaleString());
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    // -----------------------
    // SEARCH FROM ACCOUNT #
    // ----------------------- 
    useEffect(() => {
        if (!select_company_uid || !from_accountguid) return;
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );
        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", from_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );
        const unsubscribe = onSnapshot(lastQuery, (snapshot) => {
            if (!snapshot.empty) {
                setBalance(snapshot.docs[0].data().balance || 0);
            } else {
                setBalance(0);
            }
        });
        return () => unsubscribe();
    }, [from_accountguid]);


    const handle_from_search_accountgnumber = async (accountnumber) => {
        if (!accountnumber) return setFromsearchstatus(false);

        try {

            const snap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountnumber", "==", accountnumber),
                    // where("status", "==", true)
                )
            );

            if (!snap.empty) {

                setFromsearchstatus(true);
                setFrom_accountguid(snap.docs[0].data().accountguid);
                setFrom_accountdata(snap.docs[0].data());
            } else {
                setFromsearchstatus(false);
            }
        } catch (e) {
            console.error(e);
            setFromsearchstatus(false);
        }
    };

    // -----------------------
    // SEARCH TO ACCOUNT #
    // -----------------------
    useEffect(() => {
        if (!select_company_uid || !to_accountguid) return;
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );
        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", to_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );
        const unsubscribe = onSnapshot(lastQuery, (snapshot) => {
            if (!snapshot.empty) {
                setTo_balance(snapshot.docs[0].data().balance || 0);
            } else {
                setTo_balance(0);
            }
        });
        return () => unsubscribe();
    }, [to_accountguid]);


    const handle_to_search_accountgnumber = async (accountnumber) => {
        if (!accountnumber) return setTosearchstatus(false);
        try {
            const snap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountnumber", "==", accountnumber),
                    where("status", "==", true)
                )
            );
            if (!snap.empty) {
                setTosearchstatus(true);
                setTo_accountguid(snap.docs[0].data().accountguid);
                setTo_accountdata(snap.docs[0].data());
            } else {
                setTosearchstatus(false);
            }
        } catch (e) {
            console.error(e);
            setTosearchstatus(false);
        }
    };

    // -----------------------
    // FETCH VOUCHER
    // -----------------------
    const fetchvouchers = async () => {
        if (!slug || !select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            where("slug", "==", slug)
        );
        const snap = await getDocs(q);

        if (snap.empty) {
            navigate(-1);
        }

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            setVouchersdata(docs);

            const v = docs[0] || {};
            setVoucherid(v.voucherid || "");
            setVoucher(v.voucher || "");
            setdescription(v.description || "");
            setAmount(v.amount || "");
            setTotalamount(v.amount || 0);
            setOld_file_uid(v.logo_uid || "");
            setLogoUrl(v.logo_url || logo_default);
            setVoucher_type(v.voucher_type || "");
            fetchledger_accounts(v.voucherid);
        });

        return () => unsubscribe();
    };

    useEffect(() => {
        fetchvouchers();
    }, [slug]);

    // -----------------------
    // FETCH LEDGER ACCOUNTS
    // -----------------------
    const fetchledger_accounts = async (vid) => {
        if (!vid || !select_company_uid) return;

        const managerQ = query(
            collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
            where("voucherid", "==", vid)
        );

        onSnapshot(managerQ, async (snap) => {
            if (snap.empty) return setLedger_accountsdata([]);

            const mgr = snap.docs[0].data();

            const accountsSnap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", mgr.accountguid)
                )
            );

            const final = accountsSnap.docs.map((d) => ({
                ...d.data(),
                ledgertype: mgr.ledgertype,
                amount: mgr.amount
            }));

            setLedger_accountsdata(final);
        });
    };

    // -----------------------
    // COMPANY BANNER + LOGO
    // -----------------------
    const fetchCompanies = async () => {
        try {
            const snap = await getDocs(
                query(
                    collection(db, servicetablename),
                    where("uid", "==", select_company_uid)
                )
            );

            if (snap.empty) return;

            const doc = snap.docs[0].data();

            setBannerUrl(doc.banner_url || banner_default);
            setOld_banner_file_uid(doc.banner_uid || "");
            setLogoUrl(doc.logo_url || logo_default);
            setCompanyData(doc);
        } catch (e) {
            console.error("Company fetch error:", e);
        }
    };

    useEffect(() => {
        fetchCompanies();
    }, []);

    // -----------------------
    // AUTO UPLOAD LOGO
    // -----------------------
    useEffect(() => {
        const upload = async () => {
            if (!logo_file || !voucherid) return;

            const result = await Uploader_files({
                file: logo_file,
                servicetablename,
                fileuid: voucherid,
                editable: true,
                tablename: "vouchers",
                filename: "logo",
                old_file_uid
            });

            if (!result.success) return Toastshow(result.error);

            Toastshow("Successfully uploaded");
            setLogo_file(null);
            fetchvouchers();
        };

        upload();
    }, [logo_file]);

    // -----------------------
    // ESCAPE KEY → BACK
    // -----------------------
    // useEffect(() => {
    //     const handle = (e) => e.key === "Escape" && navigate(-1);
    //     window.addEventListener("keydown", handle);
    //     return () => window.removeEventListener("keydown", handle);
    // }, []);

    // ----------------------------------------------------
    // ----------------------- UI -------------------------
    // ----------------------------------------------------
    const toggleProfile = () => {
        setProfileopen(prev => !prev);
    };
    return (
        <div>
            {/* HEADER */}
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div
                                    onClick={() => navigate("/?page=vouchers")}
                                    className="button-ui0 text-h2 bold p-2 cursor fcap"
                                >
                                    <MdArrowBackIos className="icon" /> {vouchersdata[0]?.voucher}
                                </div>
                            </td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/?page=vouchers")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* DATE + RECEIPT */}
            <div className="b-bottom items-back-fill p-11">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-h3"># {receiptnumber}</td>
                            <td className="text-h3 text-r">
                                Date: {voucherdate}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* BODY */}
            <div className="voucher-entry-body">
                <div className="ui-grid-4-equal m-top">
                    {/* FROM ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon red" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold fcap red">
                                                            From Account  {from_accountdata.name || ""}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            onFocus={() => toggleProfile()}
                                            placeholder="Search from account"
                                            onChange={(e) => {
                                                const c = e.target.value.replace(/[^0-9]/g, "");
                                                e.target.value = c;
                                                handle_from_search_accountgnumber(c);
                                            }}
                                        />
                                    </td>
                                </tr>
                                {fromsearchstatus && (
                                    <>
                                        <tr>
                                            <td>
                                                <div className="button-ui2 p-2 fill text-h2">
                                                    Balance: ₹<div className="bold">{balance}</div> /-
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="items-back-fill rounded">
                                                    {fromsearchstatus && (
                                                        <>

                                                            <Ledger_accounts_profile accountguid={from_accountguid} />
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* TO ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon green" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold green fcap">
                                                            To account {to_accountdata.name || ""}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <input
                                            placeholder="Search to account"
                                            onFocus={() => toggleProfile()}
                                            onChange={(e) => {
                                                const c = e.target.value.replace(/[^0-9]/g, "");
                                                e.target.value = c;
                                                handle_to_search_accountgnumber(c);
                                            }}
                                        />
                                    </td>
                                </tr>
                                {tosearchstatus && (
                                    <>
                                        <tr>
                                            <td>
                                                <div className="button-ui2 p-2 fill text-h2">
                                                    Balance: ₹<div className="bold">{to_balance}</div> /-
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="items-back-fill rounded">
                                                    {tosearchstatus && (
                                                        <Ledger_accounts_profile accountguid={to_accountguid} />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* EMPTY */}
                    <div className="items-ui text-r"></div>

                    {/* AMOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>

                                                    <td>
                                                        <div className=" text-h2 text-off">₹ Amount</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </td>
                                </tr>
                                <tr>


                                    <td  >
                                        <table>
                                            <tr>

                                                <td>   <input
                                                    maxLength={20}
                                                    className="bold text-h2"
                                                    placeholder="Enter amount"
                                                    value={amount}
                                                    onChange={(e) => {
                                                        let v = e.target.value.replace(/[^0-9.]/g, "");
                                                        const p = v.split(".");
                                                        if (p.length > 2) v = p[0] + "." + p.slice(1).join("");
                                                        setAmount(v);
                                                        setTotalamount(v);
                                                    }}
                                                /></td>
                                            </tr>
                                        </table>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* TOTAL */}
                <div className="ui-grid-4-equal m-top b-bottom">
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>

                    <div className="items-ui text-r">
                        <div className="items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-h2 cap bold">Total amount</div>
                                        </td>
                                        <td className="text-r">
                                            <span className="text-h1 bold">₹{totalamount}/-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <AmountToWords amount={amount} />
                        </div>
                    </div>
                </div>

                {/* REMARKS AND PRINT */}
                <div className="ui-grid-4-equal m-top">
                    <table>
                        <tr>
                            <td>
                                <input className="bold text-h2 border-none items-back-fill" onChange={(e) => setRefer_number(e.target.value)} placeholder="Ref Number option"></input>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <textarea className="m-top border-none items-back-fill" row={7} maxLength={200} onChange={(e) => setRemarks(e.target.value)} rows={2} placeholder="Remark" />

                            </td>
                        </tr>
                    </table>


                    <div className="items-ui"></div>
                    <div className="items-ui">

                    </div>

                    <div className="items-ui m-1">
                        <label>
                            <input
                                type="checkbox"
                                checked={print}
                                onChange={(e) => setPrint(e.target.checked)}
                            />
                            <span className="text-h2">I want to save and print.</span>
                        </label>

                        <table>
                            <tr>
                                {print === true ? (
                                    <td>
                                        <div onClick={() => handle_save_voucher()}
                                            className="button-ui fill text-h1 p-2 cursor green-back"

                                        >
                                            <MdPrint className="icon" /> Print
                                        </div>
                                    </td>
                                ) : (
                                    <td>
                                        <div onClick={() => handle_save_voucher()}
                                            className="button-ui fill text-h1 p-2 cursor"
                                        >
                                            <MdSaveAs className="icon" /> Post
                                        </div>
                                    </td>
                                )}
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <Account_list_profile_popup
                data={"accountguid"}
                isOpen={profileopen}
                onClose={() => setProfileopen(false)}
            />
        </div>
    );
}
